import { SearchModes, TravelTypes } from '../constants';

const travelTypeToSearchMode = {
  [TravelTypes.flight]: SearchModes.FLIGHT,
  [TravelTypes.hotel]: SearchModes.HOTEL,
  [TravelTypes.cruise]: SearchModes.CRUISE_TRIP,
  [TravelTypes.carrental]: SearchModes.CAR,
  [TravelTypes.custom]: SearchModes.CUSTOM,
  [TravelTypes.tour]: SearchModes.TOUR,
};

const mapToSearchMode = (travelType) => travelTypeToSearchMode[travelType] || null;

export default mapToSearchMode;
